/* Vapurio COD theme — front-end logic.
   window.BRAND is defined in layout/theme.liquid from theme settings. */

/* brand text injection */
(function(){
  var B=window.BRAND||{};
  document.querySelectorAll('[data-brand]').forEach(function(e){e.textContent=B.name;});
  document.querySelectorAll('[data-brand-domain]').forEach(function(e){e.textContent=B.domain;});
  document.querySelectorAll('[data-brand-email]').forEach(function(e){e.textContent=B.email;});
})();

/* mobile menu (burger) */
(function(){
  var b=document.getElementById('burger'), m=document.getElementById('mobnav');
  if(!b||!m) return;
  function set(open){ b.setAttribute('aria-expanded',open?'true':'false'); if(open){m.removeAttribute('hidden');}else{m.setAttribute('hidden','');} }
  b.addEventListener('click',function(){ set(b.getAttribute('aria-expanded')!=='true'); });
  m.addEventListener('click',function(e){ if(e.target.tagName==='A') set(false); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') set(false); });
  window.addEventListener('resize',function(){ if(window.innerWidth>900) set(false); });
})();

/* marquee: duplicate content for seamless loop */
(function(){ var t=document.getElementById('mqTrack'); if(t) t.innerHTML+=t.innerHTML; })();

/* "show more reviews" */
(function(){
  var btn=document.getElementById('moreReviews'), q=document.getElementById('quotes');
  if(!btn||!q) return;
  btn.addEventListener('click',function(){ q.classList.add('expanded'); btn.style.display='none'; });
})();

/* customer-photo lightbox */
(function(){
  var lb=document.getElementById('lightbox');
  var shots=[].slice.call(document.querySelectorAll('#photostrip .pshot'));
  if(!lb||!shots.length) return;
  var img=document.getElementById('lbImg'), txt=document.getElementById('lbTxt'), name=document.getElementById('lbName');
  var i=0;
  function render(){ var s=shots[i]; img.src=s.dataset.full; txt.textContent='„'+s.dataset.txt+'“'; name.textContent=s.dataset.name+' · ✓ επιβεβαιωμένη κριτική'; }
  function open(idx){ i=idx; render(); lb.classList.add('open'); setTimeout(function(){lb.classList.add('show');},15); document.body.style.overflow='hidden'; }
  function close(){ lb.classList.remove('show'); setTimeout(function(){lb.classList.remove('open');document.body.style.overflow='';},280); }
  function go(d){ i=(i+d+shots.length)%shots.length; render(); }
  shots.forEach(function(s,idx){ s.addEventListener('click',function(){open(idx);}); });
  document.getElementById('lbX').addEventListener('click',close);
  document.getElementById('lbPrev').addEventListener('click',function(e){e.stopPropagation();go(-1);});
  document.getElementById('lbNext').addEventListener('click',function(e){e.stopPropagation();go(1);});
  lb.addEventListener('click',function(e){ if(e.target===lb) close(); });
  document.addEventListener('keydown',function(e){
    if(!lb.classList.contains('open')) return;
    if(e.key==='Escape') close(); if(e.key==='ArrowLeft') go(-1); if(e.key==='ArrowRight') go(1);
  });
})();

/* delivery estimate by region */
(function(){
  var sel=document.getElementById('regionSel');
  if(!sel) return;
  var DAYS=['Κυριακή','Δευτέρα','Τρίτη','Τετάρτη','Πέμπτη','Παρασκευή','Σάββατο'];
  var hoursEl=document.getElementById('dlHours'), s1=document.getElementById('dlStep1'),
      s2=document.getElementById('dlStep2'), s3=document.getElementById('dlStep3');
  function workday(d){ while(d.getDay()===0||d.getDay()===6){ d.setDate(d.getDate()+1); } return d; }
  function fmt(d){ return DAYS[d.getDay()]+' '+d.getDate()+'.'+(d.getMonth()+1)+'.'; }
  function update(){
    var h=parseInt(sel.value,10)||24;
    hoursEl.textContent=h;
    var now=new Date();
    // ordered today; ships within 24 h, then h hours to deliver
    var ship=workday(new Date(now.getTime()+24*3600*1000));
    var arrive=workday(new Date(ship.getTime()+h*3600*1000));
    s1.textContent='σήμερα, '+fmt(now).split(' ')[0];
    s2.textContent=fmt(ship);
    s3.textContent=fmt(arrive)+' · σε '+h+' ώρες';
  }
  sel.addEventListener('change',update);
  update();
})();

/* before/after slider (homepage) */
(function(){
  var r=document.getElementById('baRange'), top=document.getElementById('baTop'), line=document.getElementById('baLine');
  if(!r||!top||!line) return;
  var set=function(v){ top.style.clipPath='inset(0 0 0 '+v+'%)'; line.style.left=v+'%'; };
  r.addEventListener('input',function(){ set(r.value); });
  set(50);
})();

/* header shadow on scroll */
(function(){
  var h=document.getElementById('hdr'); if(!h) return;
  addEventListener('scroll',function(){ h.classList.toggle('scrolled',scrollY>8); },{passive:true});
})();

/* stat-band counters (failsafe: final value already in HTML) */
(function(){
  if(!('IntersectionObserver' in window) || document.visibilityState==='hidden') return;
  var io=new IntersectionObserver(function(es){ es.forEach(function(en){
    if(!en.isIntersecting) return; io.unobserve(en.target);
    var el=en.target, end=+el.dataset.count, t0=performance.now(), dur=1200;
    (function tick(t){ var p=Math.min(1,(t-t0)/dur), e=1-Math.pow(1-p,3);
      el.textContent=Math.round(end*e).toLocaleString('el-GR');
      if(p<1) requestAnimationFrame(tick); else el.textContent=end.toLocaleString('el-GR'); })(t0);
  }); },{threshold:.4});
  document.querySelectorAll('[data-count]').forEach(function(el){ io.observe(el); });
})();

/* gallery crossfade (image-only; motion clips are animated WebP) */
(function(){
  var main=document.getElementById('gMain'), img=document.getElementById('gImg'), thumbs=document.getElementById('thumbs');
  if(!thumbs||!img) return;
  thumbs.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b) return;
    document.querySelectorAll('#thumbs button').forEach(function(x){x.classList.remove('on');});
    b.classList.add('on');
    main.classList.add('swap');
    setTimeout(function(){ img.src=b.dataset.src; img.onload=function(){main.classList.remove('swap');}; },180);
  });
})();

/* offer selection */
var codQty=1;
/* Money: formatted in the SHOP's currency using Shopify's own money_format,
   so the page can never show a different currency than the checkout charges.
   Input is always the Shopify integer amount (minor units, e.g. 229900). */
function fmt(cents){
  var f=(window.BRAND&&window.BRAND.moneyFormat)||'{{amount_with_comma_separator}} €';
  function num(dec,group,point){
    var s=(cents/100).toFixed(dec).split('.');
    s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,group);
    return s.join(point);
  }
  return f.replace(/\{\{\s*(\w+)\s*\}\}/g,function(_,k){
    if(k==='amount_no_decimals') return num(0,',','.');
    if(k==='amount_with_comma_separator') return num(2,'.',',');
    if(k==='amount_no_decimals_with_comma_separator') return num(0,'.',',');
    if(k==='amount_with_apostrophe_separator') return num(2,"'",'.');
    return num(2,',','.');
  }).replace(/<[^>]*>/g,'').trim();
}
function currentOffer(){ return document.querySelector('.offer.on'); }
function applyOffer(el){
  if(!el) return;
  document.querySelectorAll('.offer').forEach(function(o){o.classList.remove('on');o.querySelector('input').checked=false;});
  el.classList.add('on'); el.querySelector('input').checked=true;
  // Display strings come pre-rendered from Liquid (`money` filter) — never re-invented here.
  var p=+el.dataset.price, pf=el.dataset.priceF||fmt(p), wf=el.dataset.wasF||'';
  if(wf===pf) wf='';
  window.SELECTED_VARIANT=el.dataset.variant;
  window.SELECTED_SKU=el.dataset.sku;
  window.SELECTED_QTY=+el.dataset.qty;
  window.SELECTED_PRICE=p;
  var set=function(id,txt){ var e=document.getElementById(id); if(e) e.textContent=txt; };
  var pn=document.getElementById('priceNow');
  if(pn){ pn.textContent=pf; pn.classList.remove('bump'); void pn.offsetWidth; pn.classList.add('bump'); }
  set('priceWas',wf); set('navPrice',pf); set('mPrice',pf); set('mWas',wf);
  var skuEl=document.getElementById('skuNote');
  if(skuEl) skuEl.textContent=el.dataset.sku;
  // Releasit mode: keep the native product forms pointed at the selected offer
  document.querySelectorAll('[data-cod-vid]').forEach(function(i){ if(el.dataset.vid) i.value=el.dataset.vid; });
  document.querySelectorAll('[data-cod-qty]').forEach(function(i){ i.value=el.dataset.qty||1; });
  codQty=1; syncCod();
}
document.querySelectorAll('.offer').forEach(function(o){ o.addEventListener('click',function(){applyOffer(o);}); });
(function(){
  var pre=new URLSearchParams(location.search).get('varianta');
  var preEl=pre&&document.querySelector('.offer[data-variant="'+pre+'"]');
  applyOffer(preEl||document.querySelector('.offer'));
})();

/* Releasit safety net.
   The order buttons are native Shopify product forms so Releasit COD Form (or any other COD
   app) can bind to them. The theme must NEVER touch the submit while such an app is on the
   page: an early preventDefault here is exactly what makes the app's form "not show" and the
   theme's own popup appear instead. App embeds load asynchronously, so we wait until the page
   has finished loading, re-check, and only take the buttons over if no COD app turned up. */
function codAppPresent(){
  if(window.Releasit||window.releasit||window.ReleasitCodForm||window.ReleasitCOD||window.RELEASIT) return true;
  // the app's own markup (embedded form, popup shell or trigger button).
  // Anything inside #cod-form-slot is the theme's own fallback popup — never count it.
  var hits=document.querySelectorAll('[id*="releasit" i],[class*="releasit" i],[data-releasit],'+
     '[class*="rls-" i],[id*="codform" i],[class*="cod-form" i],[data-cod-form]');
  for(var h=0;h<hits.length;h++){
    var el=hits[h];
    if(el.id==='cod-form-slot') continue;
    if(el.closest&&el.closest('#cod-form-slot')) continue;
    return true;
  }
  // a Shopify app block rendered inside our buy box
  if(document.querySelector('.pdp-app-block form,.pdp-app-block input,.pdp-app-block button,.pdp-app-block iframe')) return true;
  // app embed / theme app extension assets
  for(var i=0;i<document.scripts.length;i++){
    var src=document.scripts[i].src||'';
    if(/releasit|cod-?form/i.test(src)) return true;
    if(/cdn\.shopify\.com\/extensions\//.test(src) && /cod|cash.?on.?delivery|order.?form/i.test(src)) return true;
  }
  return false;
}
/* Is the COD app actually PAINTING something (its own order button or embedded form)?
   Loaded-but-invisible is the case where Releasit is set to "open on the theme's button" —
   then the theme button must be revealed so the app has something to bind to. */
function visible(el){ return !!(el.offsetWidth||el.offsetHeight||el.getClientRects().length); }
function codAppUiVisible(){
  /* An app block that renders nothing has zero height — that is the "Releasit button block is
     added but the app never painted it" case, and it must NOT count as the app being there. */
  var blocks=document.querySelectorAll('.pdp-app-block');
  for(var b=0;b<blocks.length;b++){ if(blocks[b].offsetHeight>0) return true; }
  var hits=document.querySelectorAll('[id*="releasit" i],[class*="releasit" i],[data-releasit],'+
    '[class*="rls-" i],[id*="codform" i],[class*="cod-form" i],[data-cod-form]');
  for(var i=0;i<hits.length;i++){
    var el=hits[i];
    if(el.id==='cod-form-slot') continue;                 // theme's own fallback markup
    if(el.closest&&el.closest('#cod-form-slot')) continue;
    if(visible(el)) return true;
  }
  return false;
}

/* App block on the page and the theme printed no form of its own. If the block paints nothing
   (app embed disabled, app failed, app blocked) the buy box would be empty with no way to
   order, so build a button and hand it to the theme's own COD popup. */
(function(){
  if(document.querySelector('form.cod-appform')) return;      // the other block handles this page
  var blocks=document.querySelectorAll('.pdp-app-block');
  if(!blocks.length) return;
  if(window.Shopify&&window.Shopify.designMode) return;       // editor: the section prints a note
  var pdp=document.querySelector('.pdp[data-product-available]');
  if(pdp&&pdp.getAttribute('data-product-available')==='0') return;  // sold out: section says so
  var made=null;
  function check(){
    var painted=false;
    for(var i=0;i<blocks.length;i++){ if(blocks[i].offsetHeight>0) painted=true; }
    if(painted){                                   // app came up (possibly late) -> drop ours
      if(made){ made.remove(); made=null; }
      return;
    }
    if(made) return;
    made=document.createElement('button');
    made.type='button';
    made.className='btn btn-accent btn-lg';
    made.setAttribute('data-open-cod','');
    made.textContent=blocks[0].getAttribute('data-cod-cta')||'Παραγγελία με αντικαταβολή';
    made.addEventListener('click',function(){ codCheckout(made); });
    blocks[blocks.length-1].insertAdjacentElement('afterend',made);
  }
  function schedule(){
    [800,2000,4000,7000].forEach(function(ms){ setTimeout(check,ms); });
    if(window.MutationObserver){
      var pending=false;
      var mo=new MutationObserver(function(){
        if(pending) return; pending=true;
        requestAnimationFrame(function(){ pending=false; check(); });
      });
      mo.observe(document.body,{childList:true,subtree:true});
      setTimeout(function(){ mo.disconnect(); check(); },20000);
    }
  }
  if(document.readyState==='complete') schedule(); else window.addEventListener('load',schedule);
})();

(function(){
  var forms=document.querySelectorAll('form.cod-appform');
  if(!forms.length) return;                      // app block path, handled above
  var ghosts=document.querySelectorAll('.cod-appform .btn.is-ghost');
  var armed=false;

  /* Keep exactly one order button on screen, whenever the app decides to show up.
     No COD app UI painted -> un-hide the theme's own button so the page is never left without
     a way to order. App UI paints later (slow connection) -> hide ours again. This has to stay
     two-way: a one-shot reveal would leave two buttons on every slow load. */
  function sync(){
    if(!ghosts.length) return;
    /* Theme editor: COD apps do not render in design mode. The section prints a neutral note
       there instead (.app-slot-note), so the buy button must stay hidden — the merchant asked
       for the app's button only, and a theme button appearing in the editor reads as a bug. */
    if(window.Shopify&&window.Shopify.designMode) return;
    var appUi=codAppUiVisible();
    ghosts.forEach(function(b){ b.classList.toggle('is-ghost', appUi); });
  }

  /* App missing entirely -> the theme's own COD popup takes the button over. Never touch the
     submit while an app is present: an early preventDefault is what makes the app's form
     "not show" and the theme popup appear instead. */
  function arm(){
    if(armed||codAppPresent()) return;
    armed=true;
    forms.forEach(function(f){
      f.addEventListener('submit',function(e){
        if(e.defaultPrevented) return;           // an app already took the submit over
        if(codAppPresent()) return;              // app showed up late -> let it do its thing
        if(!document.getElementById('codOverlay')){
          e.preventDefault();                    // Releasit mode: real cart -> checkout
          codCheckout(f.querySelector('button[type=submit]'));
          return;
        }
        e.preventDefault();
        openCodModal();                          // built-in mode: the theme's own form
      });
    });
  }
  function pass(){ sync(); arm(); }
  function schedule(){
    pass();
    [400,1200,2500,4000,7000].forEach(function(ms){ setTimeout(pass,ms); });
    /* App embeds inject whenever they finish loading — watch for it instead of guessing. */
    if(window.MutationObserver){
      /* Debounced: the observer fires on every DOM change on the page and the selector scan
         in codAppUiVisible() is not free. */
      var pending=false;
      var mo=new MutationObserver(function(){
        if(pending) return;
        pending=true;
        requestAnimationFrame(function(){ pending=false; sync(); });
      });
      mo.observe(document.body,{childList:true,subtree:true});
      setTimeout(function(){ mo.disconnect(); sync(); },20000);
    }
  }
  if(document.readyState==='complete') schedule(); else window.addEventListener('load',schedule);
})();

/* Fallback ordering when the COD app draws nothing (out of stock, embed off, app broken).
   Adds the selected offer to the cart and goes to Shopify checkout, where the customer picks
   Αντικαταβολή (COD). A real Shopify order — never the theme's look-alike form. */
function codCheckout(btn){
  var o=currentOffer();
  var vid=o&&o.dataset.vid&&parseInt(o.dataset.vid,10);
  var qty=(o&&+o.dataset.qty)||1;
  if(!vid){ window.location.href='/cart'; return; }
  var label=btn&&btn.textContent;
  if(btn){ btn.disabled=true; btn.style.opacity=.7; }
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:vid,quantity:qty}]})})
    .then(function(r){ if(!r.ok) throw r; window.location.href=(window.routes&&window.routes.checkout)||'/checkout'; })
    .catch(function(){
      /* Shopify refused the line item — almost always the variant is out of stock. Put the
         button back and say so plainly instead of bouncing the customer somewhere random. */
      if(btn){ btn.disabled=false; btn.style.opacity=''; btn.textContent=label; }
      var note=document.querySelector('.cod-stock-note');
      if(!note){
        note=document.createElement('div');
        note.className='cod-stock-note';
        note.textContent=(document.querySelector('[data-soldout-text]')||{}).textContent||
          'Το προϊόν δεν είναι διαθέσιμο αυτή τη στιγμή.';
        (btn&&btn.parentElement||document.body).appendChild(note);
      }
    });
}

/* COD modal */
var overlay=document.getElementById('codOverlay');
function syncCod(){
  var o=currentOffer(); if(!o||!overlay) return;
  var unit=+o.dataset.price;
  document.getElementById('cProdName').innerHTML=o.dataset.name+' — '+((window.BRAND&&window.BRAND.name)||'');
  document.getElementById('cProdPrice').textContent=fmt(unit);
  document.getElementById('qVal').textContent=codQty;
  var total=unit*codQty;
  document.getElementById('tSub').textContent=fmt(total);
  document.getElementById('tTotal').textContent=fmt(total);
}
function openCodModal(){
  if(!overlay) return;
  syncCod();
  document.getElementById('codBody').style.display='block';
  document.getElementById('codSuccess').style.display='none';
  overlay.classList.add('open');
  setTimeout(function(){overlay.classList.add('show');},15);
  document.body.style.overflow='hidden';
}
if(overlay){
  document.querySelectorAll('[data-open-cod]').forEach(function(b){ b.addEventListener('click',openCodModal); });
  var closeCod=function(){
    overlay.classList.remove('show');
    setTimeout(function(){ overlay.classList.remove('open'); document.body.style.overflow=''; },280);
  };
  document.getElementById('codClose').addEventListener('click',closeCod);
  overlay.addEventListener('click',function(e){ if(e.target===overlay) closeCod(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCod(); });
  document.getElementById('qMinus').addEventListener('click',function(){ if(codQty>1){codQty--;syncCod();} });
  document.getElementById('qPlus').addEventListener('click',function(){ if(codQty<9){codQty++;syncCod();} });

  /* submit -> COD webhook (Apps Script / server that creates the Shopify order) */
  document.getElementById('codForm').addEventListener('submit',function(e){
    e.preventDefault();
    var f=this, get=function(n){ return f.elements[n].value.trim(); };
    var ok=true;
    var rules={firstName:function(v){return v.length>1;}, lastName:function(v){return v.length>1;},
      phone:function(v){return /^[0-9 ]{9,}$/.test(v.replace(/[^0-9 ]/g,''))&&v.replace(/\D/g,'').length>=9;},
      street:function(v){return v.length>2;}, city:function(v){return v.length>1;}, zip:function(v){return /^\d{5}$/.test(v);}};
    Object.keys(rules).forEach(function(k){
      var fld=f.closest('.sheet-body').querySelector('.field[data-f="'+k+'"]');
      if(!rules[k](get(k))){ fld.classList.remove('bad'); void fld.offsetWidth; fld.classList.add('bad'); ok=false; }
      else fld.classList.remove('bad');
    });
    if(!ok) return;

    var o=currentOffer();
    var btn=document.getElementById('codSubmit');
    btn.disabled=true; btn.textContent='Αποστολή…';
    var reset=function(){ btn.disabled=false; btn.textContent='Ολοκλήρωση παραγγελίας — αντικαταβολή'; };
    var fail=function(){ alert('Η αποστολή απέτυχε. Δοκίμασε ξανά.'); reset(); };

    // typed details -> attached to the Shopify order as attributes + note
    var attrs={
      'Ονοματεπώνυμο': get('firstName')+' '+get('lastName'),
      'Τηλέφωνο': '+30 '+get('phone'),
      'Διεύθυνση': get('street'),
      'Πόλη': get('city'),
      'Τ.Κ.': get('zip'),
      'Προσφορά': o.dataset.name,
      'Πληρωμή': 'Αντικαταβολή (COD)'
    };
    var vid=o.dataset.vid && parseInt(o.dataset.vid,10);
    var payload={source:'cod-form',brand:(window.BRAND&&window.BRAND.name),ts:new Date().toISOString(),
      product:o.dataset.name,variantId:vid||null,sku:o.dataset.sku||'',
      unitPrice:+o.dataset.price/100,qty:codQty,total:+o.dataset.price*codQty/100,
      currency:(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR',
      payment:'Αντικαταβολή (COD)',customer:attrs};
    var showSuccess=function(){ document.getElementById('codBody').style.display='none'; document.getElementById('codSuccess').style.display='block'; reset(); };

    // Fallback route: cart -> Shopify checkout (customer picks Αντικαταβολή there).
    var viaCheckout=function(){
      if(!vid) return fail();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:vid,quantity:codQty}]})})
      .then(function(r){ if(!r.ok) throw 0;
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes:attrs, note:'Παραγγελία με αντικαταβολή (φόρμα COD)'})}); })
      .then(function(r){ if(!r.ok) throw 0; window.location.href=(window.routes&&window.routes.checkout)||'/checkout'; })
      .catch(fail);
    };

    // Preferred route: your COD endpoint creates the order with the Admin API and returns
    // { "redirect": "<order_status_url>" } — the customer lands straight on the thank-you page,
    // never seeing checkout. Endpoint must send CORS headers for this shop's domain.
    var hook=window.BRAND&&window.BRAND.orderWebhook;
    if(hook){
      fetch(hook,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){
          var url=d&&(d.redirect||d.order_status_url||d.orderStatusUrl);
          if(url){ window.location.href=url; return; }        // real Shopify thank-you page
          if(d&&d.ok){ showSuccess(); return; }               // order created, no URL returned
          viaCheckout();                                      // endpoint answered but gave us nothing usable
        })
        .catch(viaCheckout);                                  // endpoint down / CORS blocked
      return;
    }

    if(vid){ viaCheckout(); return; }

    console.log('COD ORDER (demo — no Shopify variant / webhook):',payload);
    setTimeout(showSuccess,700);
  });
}
